import useTranslation from 'shared/hooks/useTranslation';
import DotSection from 'shared/components/DotSection/DotSection';
import { Section } from 'shared/components/DotSection/Styled';
import HeaderSection from '../HeaderSection';

function Polls(): JSX.Element {
  const { t, lang } = useTranslation('surveysPage');

  const NAVIGATION_POLLS = [
    {
      id: 1,
      header: t('scrollSection.polls.contentTitle1'),
      description: t('scrollSection.polls.contentDsc1'),
    },
    {
      id: 2,
      header: t('scrollSection.polls.contentTitle2'),
      description: t('scrollSection.polls.contentDsc2'),
    },
    {
      id: 3,
      header: t('scrollSection.polls.contentTitle3'),
      description: t('scrollSection.polls.contentDsc3'),
    },
  ];

  const CONTENT_IMAGES = [
    {
      src: `/img/surveys/v2/${lang === 'pl' ? 'pl' : 'en'}/invitationType.png`,
      width: 1026,
      height: 669,
    },
    {
      src: `/img/surveys/v2/${lang === 'pl' ? 'pl' : 'en'}/saveTraffic.png`,
      width: 787,
      height: 640,
    },
    {
      src: '/img/surveys/v2/simpleCreation.png',
      width: 687,
      height: 602,
      noDots: true,
    },
  ];

  return (
    <Section>
      <HeaderSection
        topHeader={t('scrollSection.polls.topHeader')}
        header={t('scrollSection.polls.topText')}
        description={t('scrollSection.polls.description')}
      />
      <DotSection navigationItems={NAVIGATION_POLLS} images={CONTENT_IMAGES} />
    </Section>
  );
}

export default Polls;
